import React, { useRef, useEffect } from "react";
import { Icon, PermissionWrapper } from "components";
import { infoIcon, plusCircleIcon } from "assets";

// Компонент для відоброження і редагування коментарів
function RecomendationEditableInfoCell({
  item,
  editing,
  isEditable,
  onStartEditing,
  onEditChange,
  onSave,
  onCancel,
}) {
  const isCurrentlyEditing =
    editing?.article === item.article && editing?.field === "comment";
  const hasComment = !!item.comment;

  const editorRef = useRef(null);

  // Обробник для клавіш Enter та Escape
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSave();
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  // Використовуємо useEffect для відстеження кліків поза полем
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (editorRef.current && !editorRef.current.contains(event.target)) {
        onSave();
      }
    };

    if (isCurrentlyEditing) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCurrentlyEditing, onSave]);

  // Обробник редагування при подвійному кліку
  const handleDoubleClick = () => {
    // Починаємо редагування, тільки якщо ще не в режимі редагування
    if (isEditable && !isCurrentlyEditing) {
      onStartEditing(item, "comment");
    }
  };

  return (
    <>
      {hasComment || isCurrentlyEditing ? (
        <div
          className={`info-button-container ${isCurrentlyEditing ? "is-editing" : ""}`}
          ref={editorRef}
          onDoubleClick={isEditable ? handleDoubleClick : undefined}
        >
          <Icon src={infoIcon} />
          {isCurrentlyEditing ? (
            <input
              className="info-tooltip"
              type="text"
              value={editing.value}
              onChange={onEditChange}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          ) : (
            <span className="info-tooltip">{item.comment}</span>
          )}
        </div>
      ) : (
        <PermissionWrapper requiredPermission="recommendations:edit-comments">
          <button
            className="info-button-container"
            onClick={() => onStartEditing(item, "comment")}
            title="Додати коментар"
          >
            <Icon src={plusCircleIcon} />
          </button>
        </PermissionWrapper>
      )}
    </>
  );
}

export default RecomendationEditableInfoCell;
